<template>
  <div>
    <top-header
      :type="6"
      :placeholder="'楼盘资讯'"
      :hasBorder="true"
      :bgColor="'#fff'"
      fontSize="0.32rem"
    />
    <div class="pad_top"></div>
    <div class="tab_con">
      <span :class="current === 1 ? 'active' : ''" @click="changeTab(1)">今日头条</span>
      <span :class="current === 9 ? 'active' : ''" @click="changeTab(9)" v-show='pzshow'>公示公告</span>
      <span :class="current === 2 ? 'active' : ''" @click="changeTab(2)">本地楼市</span>
      <span :class="current === 3 ? 'active' : ''" @click="changeTab(3)">楼市动态</span>
      <span :class="current === 4 ? 'active' : ''" @click="changeTab(4)">房产资讯</span>
      <span :class="current === 5 ? 'active' : ''" @click="changeTab(5)">成交信息</span>
      <span :class="current === 6 ? 'active' : ''" @click="changeTab(6)">预售公示</span>
      <span :class="current === 7 ? 'active' : ''" @click="changeTab(7)">土地拍卖</span>
    </div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="no_data" v-if="!list.length">
          <img src="@/assets/img/nodata.png" alt="">
        </div>
        <div class="detail_con">
          <div
            class="inner m_flex_box flex_vc flex_jz"
            v-for="(item, index) in list"
            :key="index"
            @click="toDetail(item.nrid)"
          >
            <div class="left flex_v flex_jz">
              <h4 class="line_comp2">{{ item.mc }}</h4>
              <p class="m_flex_box flex_vc">
                <i>新闻</i>
                <span>{{item.createDate | formatTime('yyyy-MM-dd')}}</span>
              </p>
            </div>
            <img v-lazy="imgPath + 'sImgXw/' + item.imgid + '.jpg'" alt="" />
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <slide-img></slide-img>
  </div>
</template>

<script>
import qs from "qs";
import topHeader from "@/components/header";
import slideImg from '@/components/slideImg'
export default {
  name: 'NewsMain',
  data() {
    return {
      current: 1,
      isLoading: false,
      list: [],
      listPage: 1,
      loading: false,
      finished: false,
      value: "",
      timer: null,
      pzshow:false
    };
  },
  components: {
    topHeader,
     slideImg
  },
  mounted() {
    console.log("111")
    if(this.main.getHostArea()=="320382" || this.main.getHostArea()=="320381"){
      this.pzshow=true
    }
    var curr = this.$route.query.type
    if(curr){
      this.current = curr*1;
    }
  },

  filters: {
    formatTime: function (dates, fmt) {
      var date = new Date(dates);
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      var o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      };
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          var str = o[k] + '';
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
        }
      }
      return fmt;
    }
  },

  methods: {
    changeTab(id) {
      this.current = id;
      this.listPage = 1;
      this.finished = false;
      this.loading = false,
      this.list = [];
      this.onLoad();
    },
    onRefresh() {
      this.listPage = 1;
      this.finished = false;
      this.list = [];
      this.onLoad(1);
    },
    onLoad(type) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50);
        this.$new.post('news/getNewsByType.do', qs.stringify({
              pageSize: 10,
              currPageNo: this.listPage,
              xzqh: this.main.getHostArea(),
              type: this.current
            })
          )
          .then(res => {
            if (type) {
              this.isLoading = false;
            }
            if (res.success) {
              this.list = this.list.concat(res.obj);
              this.loading = false;
              this.listPage += 1;
            } else {
              this.finished = true;
            }
          });
      }
    },
    toDetail(id) {
      this.$router.push({
        path: "/newsDetail",
        query: { id }
      });
    }
  },
   beforeRouteLeave (to, from, next) {
    if (to.name === 'NewsDetail'){
      this.$store.dispatch('saveView', ['NewsMain']).then(() => {
        next()
      })
    } else {
      this.$store.dispatch('saveView', []).then(() => {
        next()
      })
    }
  },
};
</script>
<style lang="less" scoped>
.pad_top{
    padding-top: 0.8rem;
  }
.tab_con {
  position: fixed;
  background-color: #fff;
  left: 0;
  right: 0;
  top: 0.9rem;
  border-bottom: 1px solid #f5f5f5;
  height: 0.8rem;
  font-size: 0.28rem;
  padding: 0 0.23rem;
  white-space: nowrap;
  overflow: auto;
  z-index: 2;
  span {
    position: relative;
    line-height: 0.8rem;
    margin-right: 0.24rem;
    display: inline-block;
    &:last-child {
      margin-right: 0;
    }
    &.active {
      color: #2f72f5;
      font-weight: 800;
      &:after {
        content: "";
        display: block;
        background-color: #2f72f5;
        width: 0.48rem;
        height: 0.04rem;
        position: absolute;
        left: 50%;
        margin-left: -0.24rem;
        bottom: 0;
      }
    }
  }
}
.info_con {
  width: 7.04rem;
  margin: 0 auto;
  .inner {
    border-bottom: 1px solid #f5f5f5;
    padding: 0.4rem 0;
    .left {
      h4 {
        font-size: 0.32rem;
        font-weight: 800;
        color: #202020;
        margin-bottom: 0.14rem;
        line-height: 0.44rem;
      }
      .nr {
        font-size: 0.26rem;
        color: #666;
        margin: 0rem 0 0.18rem;
        line-height: 0.4rem;
      }
      .bottom_ {
        i {
          background-color: #f4f4f4;
          border-radius: 0.02rem;
          font-size: 0.22rem;
          color: #323232;
          padding: 0.02rem 0.04rem;
          margin-right: 0.18rem;
        }
        span {
          color: #909090;
        }
      }
    }
  }
}
.detail_con {
  width: 7.04rem;
  margin: 0 auto;
  .inner {
    border-bottom: 1px solid #f5f5f5;
    padding: 0.4rem 0;
    .left {
      width: 4.66rem;
      height: 1.48rem;
      h4 {
        height: 0.88rem;
        font-size: 0.28rem;
        color: #202020;
        line-height: 0.44rem;
      }
      p {
        i {
          background-color: #f4f4f4;
          border-radius: 0.02rem;
          font-size: 0.22rem;
          color: #323232;
          padding: 0.02rem 0.04rem;
          margin-right: 0.18rem;
        }
        span {
          color: #909090;
        }
      }
    }
    img {
      width: 2.08rem;
      height: 1.58rem;
    }
  }
}
</style>